module.exports = __webpack_public_path__ + "media/images/flags/32/Burundi-c4cadb4167bb2acfba3a0cfec3f08a3e.png";